"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.ContentType = void 0;
/* eslint-disable no-unused-vars */
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (exports.ContentType = ContentType = {}));
/* eslint-enable no-unused-vars */
class HttpClient {
    request = async (params) => {
        //some dummy strings, so compiler won't complain our empty stub
        const e = typeof this.request === 'function' && undefined;
        if (params.method === e)
            return Promise.resolve(null);
        return Promise.resolve(null);
    };
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=http-client.js.map